import { render, staticRenderFns } from "./Thumbs.vue?vue&type=template&id=5e5c1c58&scoped=true"
import script from "./Thumbs.vue?vue&type=script&lang=js"
export * from "./Thumbs.vue?vue&type=script&lang=js"
import style0 from "./Thumbs.vue?vue&type=style&index=0&id=5e5c1c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5c1c58",
  null
  
)

export default component.exports